import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { DataService } from '../../../../core/services/data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-set-pin',
  templateUrl: './set-pin.component.html',
  styleUrls: ['./set-pin.component.scss'],
})
export class SetPinComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private authService: AuthService,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    // Ladeindikator aktiviert
    this.getData();
    // Prüfung ob Pin gesetzt ist
    this.authService.hasPin().then((r) => {
      if (r) {
        console.log('[SET PIN]: Pin already set -> validate Login');
        console.log(r);
        this.authService.validateLogin(r as string);
        console.log('[SET PIN]>[ROUTER]: Navigate pack-download');
        //this.router.navigate(['/pack-download']);
      } else {
        console.log('[SET PIN]: Pin not set');
      }
    });
  }

  // Wird ausgeführt, wenn Pin vollständig eingeben wurde
  setPinCompleted(code: string): void {
    console.log('[SET PIN]: Pin set -> validate Login');
    this.authService.validateLogin(code);
    console.log('[SET PIN]>[ROUTER]: Pin Set Navigate pack-download');
    //this.router.navigate(['/pack-download']);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  // Collections und Produktdatenabruf
  getData(): void {
    console.log('[LOGIN]: Get data');

    const translationsSub = this.dataService.translationsLoaded$.subscribe(
      (loaded) => {
        console.log(
          '[LOGIN]: Translations loaded check - Subscription: ' + loaded
        );
      }
    );
    this.subscriptions.push(translationsSub);
  }
}
